var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-actions"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"title":"Editar"},on:{"click":function($event){_vm.editar(_vm.rowData)}}},[_c('i',{staticClass:"fa fa-pencil"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dcd2358","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomActions.vue
// module id = null
// module chunks = 